import _, { reduce } from 'lodash';
import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import { inject, observer } from 'mobx-react';
import autobind from 'autobind-decorator';
import { DragDropContext, Droppable, Draggable } from 'react-beautiful-dnd';

import moment from 'moment';
import TableComponent from 'common/components/table-component';
import { SelectColumnFilter,  NumberRangeColumnFilter, calcTimeSince } from 'common/components/table-component/table-component';

import HFMDragDropContext from '../hfm-drag-drop-context';

const filterSelectedItems = (selectedItems = [], itemList) => {
	return itemList.filter((item) => {
		return selectedItems.map(({ _id }) => _id).indexOf(item._id) === -1;
	});
};

const AlbumListItem = ({ _id, artistName, name, onClick, icon }) => {
	return (
		<div className="grid-x align-middle" data-ta="albumListItem">
			<div className="cell small shrink">
				<button
					key={ _id }
					data-id={ _id }
					data-ta="addAlbumBtn"
					onClick={ onClick }
					style={{
						textAlign: 'left'
					}}
					className="button secondary clear expanded margin-bottom-0">
						<span
							className={ `fas fa-${icon}` }
							style={{
								margin: '0',
								float: 'left'
							}}>
						</span>
				</button>
			</div>
			<div className="cell small auto">
				<b>{ name }</b>
				<br />
				<em>{ artistName }</em>
			</div>
		</div>
	);
};

const AlbumList = ({ albums, icon, ItemOnClick, cellSize, filterable, searchChange , getArtistName }) => {
	return (
	<div className={ `cell small-${ cellSize }` } >
		<h5>Album List</h5>
		<div className="dnd-album-list" data-ta="albumList" _id="albumList">
			{
				albums.map(({ _id, artistID, name }) => (
					<AlbumListItem
						key={ _id }
						id={ _id }
						_id={ _id }
						icon={ icon }
						onClick={ ItemOnClick }
						artistName= { this.getArtistName(artistID) }
						name={ name }  />
				))
			}
		</div>
	</div>
	);
};

@inject('artistStore', 'songsStore')
@observer
class ItemList extends Component {
	// Normally you would want to split things out into separate components.
	// But in this example everything is just done in one place for simplicity
	render() {
		const { listType } = this.props;
		const { itemList, selectedItems, genre } = this.props;
		const numCells = 3;
		const cellSize = 12 / numCells;
		const items = filterSelectedItems(selectedItems, itemList);

		const songTableCols = [
			{
			id: 'songTable',
			columns: [
				{
					// Header: 'songID',
					accessor: '_id',
					Cell: ({value, row}) => { return (this.renderAddButton(value)) },
					disableSortBy: true,
					disableFilters: true,
				},
				{
					Header: <i  title='SortBy EXPLICIT!' className="far fa-exclamation-square"  style={{ color: 'red' }} />,
					accessor: s => {return (s.explicit == true ? 'true' : 'false')},
					id: 'explicit',
					Filter: SelectColumnFilter,
					Cell: ({value, row}) => { return (
						value == 'true' ? <i title='EXPLICIT!' className="far fa-exclamation-square" style={{ color: 'red' }}/> : null
					)},
				},
				{
					Header: <i title='SortBy New Releases' className="far fa-sparkles" style={{ color: 'gold' }} />,
					accessor: s => {return (calcTimeSince(s.dateAdded, {verbose: false, timeType: 'DAYS' }) < 90  ? 'true' : 'false')},
					id: 'dateAddedSparkle',
					Filter: SelectColumnFilter,
					filter: 'includes',
					sortType: 'basic',
					Cell: ({value, row}) => { return (
						(value == 'true' ? <i title='New Release' className="far fa-sparkles" style={{ color: 'gold' }} /> : null) 
					)},
				},
				{
					Header: <i className="far fa-play-circle" />,
					id: 'previewSong',
					Filter: SelectColumnFilter,
					filter: 'includes',
					sortType: 'basic',
					Cell: ({value, row}) => { return (
						<span className="far fa-play-circle" onClick={ this.onPlayClick }></span>
					)},
				},
				{
					Header: 'Title',
					accessor: 'title',
					sortType: 'alphanumeric',
				},
				{
					Header: 'Artist',
					accessor: s => this.getArtistName(s.artistID),
					sortType: 'alphanumeric',
				},
				// {
				// 	Header: 'Album',
				// 	accessor: 'email',
				// 	sortType: 'basic'
				// },
				{
					Header: 'Genre',
					accessor: s => this.getArtistGenre(s.artistID).label,
					id: 'genre',
					sortType: 'basic',
					Filter: SelectColumnFilter,
					// filter: 'includes',
				},
				{
					Header: '# Plays',
					accessor: 'plays',
					sortType: 'basic',
					Filter: NumberRangeColumnFilter,
					filter: 'between',
				},
				{
					Header: 'Date Added',
					accessor: 'dateAdded',
					sortType: 'basic',
					Cell: ({value}) => { return moment(value).format('YYYY-MM-DD')+ ` (${calcTimeSince(value)})` }
				},
			],
			},
		];


		const artistTableCols = [
			{
			id: 'artistTable',
			columns: [
				{
					// Header: 'songID',
					accessor: '_id',
					Cell: ({value, row}) => { return (this.renderAddButton(value)) },
					disableSortBy: true,
					disableFilters: true,
				},
				{
					Header: <i title='SortBy New Artists' className="far fa-sparkles" style={{ color: 'gold' }} />,
					accessor: s => {return (calcTimeSince(s.createdAt, {verbose: false, timeType: 'DAYS' }) < 90  ? 'true' : 'false')},
					id: 'createdAtSparkle',
					Filter: SelectColumnFilter,
					filter: 'includes',
					sortType: 'basic',
					Cell: ({value, row}) => { return (
						(value == 'true' ? <i title='New Artist' className="far fa-sparkles" style={{ color: 'gold' }} /> : null) 
					)},
				},
				{
					Header: 'Artist',
					accessor: 'name',
					sortType: 'alphanumeric',
					// Cell: ({value, row}) => { return <a href={`/admin/#/artist/info/${row.values["_id"]}`}>{value}</a>  },
				},
				{
					Header: 'Label',
					accessor: 'label',
					Cell: ({value}) => { return value || '- No Label -'  },
					sortType: 'basic'
				},
				{
					Header: 'Genre',
					accessor: 'genre.label',
					id: 'genre',
					sortType: 'basic',
					Filter: SelectColumnFilter,
					// filter: 'includes',
					// Cell: ({value, row}) => { return row.original.genre.label },
				},
				{
					Header: 'Join Date',
					accessor: 'createdAt',
					sortType: 'basic',
					Cell: ({value}) => { return moment(value).format('YYYY-MM-DD') + ` (${calcTimeSince(value)})` }
				},
				{
					Header: 'Catalog Size',
					accessor: 'songs.length',
					sortType: 'basic',
					Filter: NumberRangeColumnFilter,
					filter: 'between',
				},
			],
			},
		];


		let muzadoListBox = false;
		if (listType == "ARTIST") { 
			muzadoListBox = 
				<div className={ `grid-x cell small-8 margin-right-2` } style={{
					'max-width': '55vw',
					overflowX: 'scroll',
				}}>
					<TableComponent
						tableCols={ artistTableCols }
						data={ items }
						initialState={{
							pageIndex: 0,
							sortBy: [
								{ id: "name", desc: false }
							],
							filters: [
								{ id: `${ genre._id != 0 ? 'genre' : null }`, value: `${ genre._id ? genre.label : null }`}
							],
							// hiddenColumns: ["_id"],
							filtersVisible: true,
						}} 
					/>
				</div>
		} else if (listType == "ALBUM") {
			muzadoListBox = 
				<AlbumList
				style={{
					'max-width': '55vw',
					overflowX: 'scroll',
				}}
					albums={ items }
					icon="plus"
					ItemOnClick={ this.addItem }
					cellSize={ cellSize }
					nameFunc={ this.getArtistName }
					filterable={ true }  
					searchChange={ this.searchAlbumChange }
					getArtistName={ this.getArtistName }
				/>
		} else { //if (listType == "PLAYLIST" || listType == "SONGS"  || listType == "NEW_RELEASES")
			muzadoListBox = 
				<div className={ `grid-x cell  small-8 margin-right-2` } style={{
					'max-width': '55vw',
					overflowX: 'scroll',
				}} >
					<TableComponent
					
					tableCols={ songTableCols }
					data={ items }
					initialState={{
						pageIndex: 0,
						sortBy: [
						{
							id: "title",
							desc: false
						}
						],
						// hiddenColumns: ["_id"],
						filtersVisible: true,
					}} />
				</div>
		}

		return (
			<div className="grid-x album-form-song-list">

				{ muzadoListBox }

				<div 
					className={ `cell small-3` }
					style={{textAlign:"center", background: '#f3f3f3'}}
					data-ta="selectedSongs" >
					{/* <div>
						<i className="fas fa-search"></i> Search Box goes here
					</div> */}
					<h4 style={{background:'black', color:'white'}}>Selected Items</h4>
					<HFMDragDropContext
						className='dnd-admin-item'
						dragDropList={ selectedItems }
						onDragEnd={ this.props.onDragEnd }
						ItemLabel={ (listType == "ARTIST" ? this.renderArtistLabel : (listType == "ALBUM" ? this.renderAlbumLabel : this.renderLabel)) }
						ItemButton={ this.renderRemoveButton } />
				</div>
			</div>
		);


	}

	@autobind
	selectArtist ({ target }) {
		let realTarget = (target.tagName == "BUTTON" ? target.parentNode.parentNode : target.parentNode.parentNode.parentNode);
		
		const artistList = document.getElementById("ARTISTList").children;
		for (let j = 0; j < artistList.length; j++) {
			artistList[j].style = "background-color: inherit;";
		}
		realTarget.style = "background-color: grey;";
		
		const filter = realTarget.children[1].textContent;
		
		const list = document.getElementById("SONGList").children;
		for (let i = 0; i < list.length; i++) {
			let item = list[i];
			const txt = item.children[1].children[1].textContent;
			if (txt.match(RegExp(filter, "ig"))) {
				item.style = "visibility: visible;";
			} else {
				item.style = "visibility: collapse; height:0px !important;";
			}
		}
	}

	@autobind
	addItem ({ target }) {
		const { addItem } = this.props;
		const el = target.localName === 'span' ? target.parentElement : target;
		addItem(el.dataset.id);
	}

	@autobind
	removeItem ({ target }) {
		const { removeItem } = this.props;
		const el = target.localName === 'span' ? target.parentElement : target;
		removeItem(el.dataset.id);
	}

	@autobind
	renderRemoveButton ({ _id }) {
		return (
			<button
				key={ _id }
				data-id={ _id }
				onClick={ this.removeItem }
				className="button secondary clear margin-bottom-0">
					<span className="fas fa-minus"></span>
			</button>
		);
	}

	@autobind
	// renderSongLabel ({ title, artistID }) {
	renderLabel ({ title, artistID }) {
		return (
			<div>
				<div>{ (title ? title : '-- MISSING TITLE --') }</div>
				<div><em>{ this.getArtistName(artistID) }</em></div>
			</div>
		);
	}

	@autobind
	renderArtistLabel ({ name }) {
		return (
			<div>
				{ name }
			</div>
		);
	}

	@autobind
	renderAlbumLabel ({ name, artistID }) {
		return (
			<div>
				{ name }
				<br />
				<em>{ this.getArtistName(artistID) }</em>
			</div>
		);
	}

	@autobind
	getArtistName (artistID) {
		const { artistStore } = this.props;
		const artist = artistStore.getArtistByID(artistID);
		return _.isObject(artist) ? artist.name : '-- Artist name not found --';
	}

	@autobind
	getArtistGenre (artistID) {
		const { artistStore } = this.props;
		const artist = artistStore.getArtistByID(artistID);
		return _.isObject(artist) ? artist.genre : '-- Artist not found --';
	}

	@autobind
	renderAddButton(value) { return (
		<button
			key={ value }
			data-id={ value }
			data-ta="addSongBtn"
			onClick={ this.addItem }
			style={{ textAlign: 'left' }}
			className="button secondary clear expanded margin-bottom-0">
			<span
				className={ `fas fa-plus` }
				style={{
					margin: '0',
					float: 'left'
				}}>
			</span>
		</button>
	);}

	@autobind
	onPlayClick () {
		this.props.songsStore.currentSongPlayback = this.props.song;
	}

}

export default ItemList;
